import getEnvironment from "../getEnvironment";

export const IS_PRODUCTION = getEnvironment() === "production";

export const UAT_MAGNOLIA_ROOT_URL = "https://cms.uat.britishcarauctions.net";

export const MAGNOLIA_ROOT_URL = IS_PRODUCTION ? "https://www.bca.co.uk" : UAT_MAGNOLIA_ROOT_URL;

// Pages

export const CONTACT_US_URL = `${MAGNOLIA_ROOT_URL}/contact-us`;
